export enum AdditionalDocumentationType{
    AdditionalDocumentationASOO = 1,
    AdditionalDocumentationMZOM = 2
}